import { Sprite, Texture } from "pixi.js";

export default class Heart {
  public sprite: Sprite;
  public texOn: Texture;
  public texOff: Texture;
  public id: number;
  constructor(sprite: Sprite, texOn: Texture, texOff: Texture, id: number) {
    this.sprite = sprite;
    this.texOn = texOn;
    this.texOff = texOff;
    this.id = id;
  }

  reset() {
    this.sprite = null as any;
  }
}
